<template>
  <div class="product">
    <div class="banner">
      <div class="title">智能数据管理</div>
      <div class="desc">
        <section>以数据驱动的高效营销体验，精准把握每一次传播的数据监测回流，</section>
        <section>反哺内容的优化迭代，形成营销闭环</section>
      </div>
       <router-link target="_blank"  to='/contact'>
        <div class="button">立即体验
          <i class="el-icon-right"></i>
        </div>
      </router-link>
    </div>
    <div class="context">
      <div class="titleRow">
            <div class="title">全面且精准的数据管理系统</div>
            <div class="desc">
                <section>能力覆盖全社交平台及端内私域分发的数据监测回流，为企业提供全场景、</section>
                <section>多维度的数据分析管理能力</section>
            </div>
      </div>
      <div class="row">
        <div class="introduce right">
          <div class="idesc">
            <section class='title'>全面可视化的数据看板</section>
            <section>端到端的数据分析系统，超过 100+的数据分析指标，让企业的</section>
            <section>内容营销数据效果一目了然</section>
            <section class='title'>打通全域的数据分析能力</section>
            <section>端内的私域内容分发数据与国内主流互联网广告/新媒体平台</section>
            <section>数据监测回流，为企业提供实时的营销数据反馈</section>

          </div>
          <router-link target="_blank"  to='/contact'>
            <div class="button">了解更多
              <i class="el-icon-right"></i>
            </div>
          </router-link>

        </div>
        <img class="img"  :src="`https://respool.isheji.com/isheji/static/qiye/image/home/path_card_9.png`">
      </div>
      <div class="titleRow">
            <div class="title">新媒体大数据平台</div>
            <div class="desc">
                <section>新媒体榜单、数据流量监测、投放前中后数据报告一体化服务提升新媒体投放效率，</section>
                <section>让广告主投放有据可依</section>
            </div>
      </div>
      <div class="row">
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/product/data/2.png">
        <div class="introduce left">
          <div class="idesc">
            <section class='title'>营销全链路的数据监测能力</section>
            <section>kol投放前中后期的数据分析能力，用户画像、竞品投放、分钟级流量去水监测、投后数</section>
            <section>据回流监测一站式服务</section>
            <section class='title'>国内主流新媒体平台全量覆盖</section>
            <section>针对公域的内容分发，可以实现对微博、微信、抖音、快手、B 站、小红书等，平台 </section>
            <section>kol 的价值评估、流量监测与数据分析回流</section>
            <section class='title'>10余年超级品牌服务经验</section>
            <section>10余年新媒体营销数据分析能力储备，建立新媒体价值指数（KOLRANK），已为阿里、</section>
            <section>字节、美团、欧莱雅等超级品牌提供数据分析管理服务</section>
          </div>
          <router-link target="_blank"  to='/contact'>
            <div class="button">了解更多
              <i class="el-icon-right"></i>
            </div>
          </router-link>
        </div>
      </div>

    </div>
     <banner></banner>
  </div>
</template>
<script>
import banner from '@/components/productBanner.vue'
export default {
  name: 'data',
  components: {
    banner,
  },
}
</script>
<style lang="scss" scoped>
.product{
    width: 100%;
    min-width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .banner{
      text-align: center;
      background-image: url('https://respool.isheji.com/isheji/static/qiye/image/product/data/banner.png');
      width: 100%;
      min-width: 1400px;
      height: 460px;
      background-size: cover;
      background-position-x: center;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 60px;
      .title{
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 45px;
      }
      .desc{
        margin-top: 20px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 22px;
        margin-bottom: 32px;
      }

    }
    .context{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-width: 1400px;
        padding-bottom: 78px;
      .drak{
        background: #F7F7F9;
      }
      .titleRow{
        text-align: center;
        width: 100%;
        padding-top: 80px;
        padding-bottom: 54px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .title{
            font-size: 32px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #3B3946;
            line-height: 45px;
        }
        .desc{
            margin-top: 6px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6E6C76;
            line-height: 22px;
        }
      }
      .row{
        display: flex;
        justify-content: center;
        width: 100%;
        align-items: center;
        .left{
          margin-left: 142px;
        }
        .right{
          margin-right: 142px;
        }
        .introduce{
          .iheader{
            display: flex;
            align-items: center;
            img{
              width: 60px;
              height: 60px;
              border-radius: 8px;
            }
            .iTitle{
              margin-left: 18px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              .bold{
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 33px;
              }
              .thin{
               font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 22px;
              }
            }
          }
          .idesc{
            margin-top: 24px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6E6C76;
            line-height: 24px;
            margin-bottom: 32px;

            .title{
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 28px;
                margin-bottom: 6px;
                margin-top: 8px;
                display: flex;
                align-items: center;
                  &::before{
                    content: '';
                    margin-right: 8px;
                    width: 12px;
                    height: 6px;
                    background: #5A2DF5;
                    border-radius: 1px;
                    display: block;
                }
            }
          }
        }
        .img{
          width: 595px;
        }

      }
    }

     .button{
        width: 126px;
        height: 44px;
        background: #5A2DF5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
          .el-icon-right{
            display: none;
            margin-left: 8px;
          }
        &:hover{
          .el-icon-right{
            display: block;
            margin-left: 8px;
            color: #FFFFFF;
          }
        }
      }
}
</style>
